import instance from './instance'

const offerUrl = 'modules-coupon/offers'

export const getOfferList = (page: number, pageSize: number, filterKey: any) =>
  instance.get(`${offerUrl}?page=${page}&pageSize=${pageSize}&filterkey=${filterKey}`)

export const getOfferById = (id: number) => instance.get(`${offerUrl}/${id}`)

export const createOffer = (payload: any) => instance.post(offerUrl, payload)

export const updateOffer = (id: number, payload: any) =>
  instance.post(`${offerUrl}/${id}`, payload)

export const deleteOffer = async (id: number) => await instance.delete(`${offerUrl}/${id}`)
